import { useEffect, useState } from 'react'

import {
  type SuccessReadUserOrdersV2,
  type UserOrderResponseWithFlags,
} from '@redteclab/api/clients/bully'

interface UseOrdersHook {
  data?: SuccessReadUserOrdersV2
}

export const useDirectContactFormOrders = ({
  data,
}: UseOrdersHook): UserOrderResponseWithFlags[] => {
  const [orders, setOrders] = useState<UserOrderResponseWithFlags[]>([])

  const isOrderNew = (
    order: UserOrderResponseWithFlags,
    prevState: UserOrderResponseWithFlags[],
  ): boolean => {
    return !prevState.some(
      (existingOrder) =>
        existingOrder.orderMasterData?.orderNumber ===
        order.orderMasterData?.orderNumber,
    )
  }

  useEffect(() => {
    setOrders((prevState) => {
      if (data?.orders) {
        const newOrders = data.orders.filter((order) =>
          isOrderNew(order, prevState),
        )

        return [...prevState, ...newOrders]
      }

      return prevState
    })
  }, [data, setOrders])

  return orders
}
